module.exports = __webpack_public_path__ + "img/filetypePdf.ef668c51.svg";